import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'

const baseRoute = OneNetworkConfig.baseRoutePath

export const ItemWidgetsList = [
  {
    key: 'total_account',
    icon: 'bxs:user',
    label: 'Quản lý thành viên',
    path: `${baseRoute}/account/list`,
    badgeCount: 0,
    perm: 'account.list_acc',
  },
  {
    key: 'total_pending_kyc',
    icon: 'bxs:user-check',
    label: 'Phê duyệt KYC',
    path: `${baseRoute}/account/kyc`,
    badgeCount: 10,
    perm: 'account.approve_kyc',
  },
  {
    key: 'total_bo_account',
    icon: 'mdi:user-badge',
    label: 'Quản lý tài khoản Back Office',
    path: `${baseRoute}/account/bo`,
    badgeCount: 0,
    perm: 'account.list_bo',
  },
  {
    key: 'total_deposit',
    icon: 'tabler:moneybag-plus',
    label: 'Nạp tiền',
    path: `${baseRoute}/transaction/deposit`,
    badgeCount: 0,
    perm: 'transaction.deposit',
  },
  {
    key: 'total_withdrawal_request',
    icon: 'tabler:moneybag-minus',
    label: 'Yêu cầu rút tiền ',
    path: `${baseRoute}/transaction/withdraw`,
    badgeCount: 0,
    perm: 'transaction.withdraw',
  },
  {
    key: 'total_transaction',
    icon: 'mage:money-exchange',
    label: 'Lịch sử giao dịch',
    path: `${baseRoute}/transaction/history`,
    badgeCount: 0,
    perm: 'transaction.list',
  },
  {
    key: 'total_broker',
    icon: 'fa-solid:user-tie',
    label: 'Danh sách môi giới',
    path: `${baseRoute}/broker/list`,
    badgeCount: 0,
    perm: 'broker.list',
  },
  {
    key: 'total_pending_broker',
    icon: 'pajamas:approval-solid',
    label: 'Phê duyệt môi giới ',
    path: `${baseRoute}/broker/approval`,
    badgeCount: 0,
    perm: 'broker.approve',
  },
  {
    key: 'total_real_estate',
    icon: 'lucide:land-plot',
    label: 'Danh sách tài sản',
    path: `${baseRoute}/property/items`,
    badgeCount: 0,
    perm: 'real_estate.list',
  },
  {
    key: 'total_listing',
    icon: 'fluent:building-home-16-filled',
    label: 'Quản lý tin đăng',
    path: `${baseRoute}/property/listings`,
    badgeCount: 0,
    perm: 'real_estate.list',
  },
  {
    key: 'total_pending_listing',
    icon: 'bi:house-check-fill',
    label: 'Phê duyệt tin đăng',
    path: `${baseRoute}/property/approval`,
    badgeCount: 0,
    perm: 'real_estate.approve',
  },
  {
    key: 'total_flash_offer',
    icon: 'fluent:flash-sparkle-24-regular',
    label: 'Quản lý Flash Offer',
    path: `${baseRoute}/flash-offer/list`,
    badgeCount: 0,
    perm: 'flash_offer.list',
  },
  {
    key: 'total_consultation',
    icon: 'ix:customer-filled',
    label: 'Tra cứu khách hàng',
    path: `${baseRoute}/customers/list`,
    badgeCount: 0,
    perm: '*'
  },
  {
    key: 'total_contract',
    icon: 'clarity:contract-line',
    label: 'Tra cứu hợp đồng',
    path: `${baseRoute}/contracts/list`,
    badgeCount: 0,
    perm: 'contract.list',
  },
  {
    key: "total_support_service",
    icon: 'zondicons:link',
    label: 'Dịch vụ liên kết',
    path: '',
    badgeCount: 0,
    perm: 'linked_service.list',
  },
  {
    icon: 'bxs:pie-chart-alt-2',
    label: 'Thống kê sử dụng app',
    path: '',
    badgeCount: 0,
    perm: 'report.usage',
  },
  {
    icon: 'bxs:pie-chart-alt-2',
    label: 'Thống kê giao dịch',
    path: '',
    badgeCount: 0,
    perm: 'report.transaction',
  },
  { icon: 'bxs:pie-chart-alt-2', label: 'Thống kê khách hàng', path: '', badgeCount: 0, perm: '*' },
  {
    icon: 'bxs:pie-chart-alt-2',
    label: 'Thống kê hoa hồng',
    path: '',
    badgeCount: 0,
    perm: 'report.commission',
  },
  {
    icon: 'mingcute:announcement-fill',
    label: 'Gửi tin hàng loạt',
    path: '',
    badgeCount: 0,
    perm: 'cs.bulk_message',
  },
]
